import type { PartnerRole } from "@dearbill/shared";

/**
 * Human label for a partner's role within an organization, shown for each
 * membership in the org list.
 */
export function partnerRoleLabel(role: PartnerRole): string {
  return role === "org_admin" ? "Organization admin" : "Member";
}
